<div class="paddedContent" style="padding-top: 30px">
  <div style="margin-bottom: 10px">
    <app-ddl-input
      [options]="brandOptions"
      [label]="'Brand'"
      [(ngModel)]="selectedBrandId"
    ></app-ddl-input>
    <app-ddl-input
      [options]="months"
      [(ngModel)]="selectedMonth"
      [label]="'Select a month'"
    ></app-ddl-input>
    <app-ddl-input
      [options]="years"
      [(ngModel)]="selectedYear"
      [label]="'Select a year'"
    ></app-ddl-input>
  </div>

  <div style="margin-bottom: 10px">
    <!-- 
            since we can't really style a native file input, we just hide it
            and trigger its click event from our own, visible button 
        -->
    <div style="display: flex; justify-content: space-between">
      <div style="flex: 1">
        <input
          type="button"
          value="Select file"
          class="button_secondary button_var_2"
          style="padding: 5px 10px"
          (click)="selectFiles_click()"
        />
        <input
          type="file"
          id="fileUpload"
          multiple="false"
          style="width: 0px; height: 0px"
          (change)="onFilesSelected($event)"
        />
      </div>
      <div style="flex: 3" [hidden]="fileUpload == undefined">
        {{ fileUpload?.file?.name }}
      </div>
    </div>
  </div>

  <div [hidden]="fileUpload == undefined">
    <div style="text-align: center">
      <input
        type="button"
        value="Create Report"
        class="button_primary button_var_2"
        style="padding: 5px 10px"
      />
    </div>
  </div>
</div>
